import React from 'react';
import PrintText from './PrintText';
import { Field } from 'redux-form/immutable';
import { renderField } from './_FORM_FIELDS';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import commaNumber from 'comma-number';

const MediumText = (props) => {
  const { layoutItem, workflowData } = props
  let htmlTagEditor = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.htmlEditorContent
  let cssEditorContent = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.cssEditorContent
  const enableCommaSep = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.externalComponentConfig && layoutItem.itemProperties.externalComponentConfig.enableCommaSep
 
  let replacedHtml = htmlTagEditor.replace(/\{\{(.*?)\}\}/g, (match, key) => {
    key = key.trim();
    let originalVal = ModelPropertiesParser(match, workflowData)
    if (enableCommaSep) {
      if (originalVal !== null && originalVal !== undefined) {

        if (!isNaN(originalVal)) {

          originalVal = commaNumber(originalVal)


        }
      }
    }

    return originalVal ? originalVal : "";
  });
  return (
    <div className="html-preview">
      <style>
        {`
      .html-preview ${cssEditorContent || ""}
    `}
      </style>
      <div dangerouslySetInnerHTML={{ __html: replacedHtml }} />
    </div>
  );
}

export default MediumText;